/**
 * Sincronização de parceiros com a API.
 * A API deve implementar:
 * - POST /api/parceiros/sync — recebe { guias, agencias, associacoes }; atualiza status em parceiros-app e upsert em DynamoDB
 * - POST /api/parceiros/notificacao - recebe { toEmail, tipo: 'aprovado'|'recusado', mensagem? } para enviar aviso ao parceiro
 */

import { apiUrl } from './api';
import type { Associacao } from './associacoesStorage';
import type { Guia, Agencia } from './guiasAgenciasStorage';

export async function syncParceirosToApi(
  guias: Guia[],
  agencias: Agencia[],
  associacoes: Associacao[]
): Promise<boolean> {
  try {
    const res = await fetch(apiUrl('/api/parceiros/sync'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ guias, agencias, associacoes }),
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function enviarNotificacaoParceiro(
  toEmail: string,
  tipo: 'aprovado' | 'recusado' | 'inativo',
  mensagem?: string
): Promise<boolean> {
  try {
    const res = await fetch(apiUrl('/api/parceiros/notificacao'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ toEmail, tipo, mensagem }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
